import { AddressObject } from '../../../hooks/useAddressSearch';
import { evaluateResponseErrorCode, getApiError } from '../../errors';
import { post } from '../../http';

export interface IEnrollmentPayload {
  firstName: string;
  lastName: string;
  email: string;
  login: string;
  mobilePhone: string;
  birthDate: string;
  credentials: { password: string };
  canadianOptIn: boolean | undefined;
  address?: AddressObject;
  partner?: { name: string; tokenKey: string };
}

export interface IEnrollmentResponse extends Omit<IEnrollmentPayload, 'credentials' | 'canadianOptIn' | 'partner'> {
  mgmId: string;
  profileCoreId: string;
  created: string;
  updated: string;
  primaryPhone: string | null;
  secondEmail: string | null;
  mlifeNumber: string;
  gseId: string | null;
  loyaltyTier: string;
  status: string;
  createdBy: string;
  enrollmentSource: string;
  emailVerified: boolean;
}

export const enrollUser = async (requestBody: string, headers?: Headers) => {
  try {
    const result = await post('/signUp/code', {
      body: requestBody,
      headers,
    });

    evaluateResponseErrorCode(result.response);

    return result.response;
  } catch (error) {
    throw getApiError(error);
  }
};

export const signUpVerificationRequest = async (
  requestBody: string,
  headers?: Headers,
): Promise<IEnrollmentResponse> => {
  try {
    const result = await post('/signUp/verify', {
      body: requestBody,
      headers,
    });

    evaluateResponseErrorCode(result.response);

    return result.response;
  } catch (error) {
    throw getApiError(error);
  }
};
